<template>
    
<div class="modal">
<h2>Как искать</h2>
<br>
<p>Поиск на данный момент одновременно осуществляется по именам фалов, по каталогам до файла от корневой папки «Россхема», и по полному пути до файла от корневого каталога. При поиске допускается использование регулярных выражений(PCRE).  Что такое регулярные выражения и как ими пользоваться на практике для поиска по «Россхеме» мы сейчас попробуем по-быстрому разобраться.
В регулярках используются так называемые метасимволы, расписывать целиком PCRE не вижу никакого смысла, считаю, что для перекрытия 99% задач поиска достаточно следующих:</p>
<br>
<p>^ -начало строки. Текст, следующий после этого символа должен находится в начале строки.</p>
<p>$ -конец строки. Текст, находящийся перед этим символом должен находится в конце строки.</p>
<p>. -один произвольный символ, абсолютно любой символ.</p>
<p>| - оператор или.</p>
<p>() – группировка. Ведет себя точно так же, как и обычные математические скобки.</p>
<br>
<p>Так же есть еще так называемые модификаторы. Для нас интересны только три следующих:</p>
<p>* - повторение 0 и больше раз</p>
<p>+ - повторение 1 и больше раз</p>
<p>? – 0 или 1 раз.</p>
<br>
<p>А теперь к практике.</p>
<p>На самом деле на данный момент, по умолчанию все пробелы в поисковом запросе заменяются на регулярное выражение «.?». Что мы тут видим? Используется метасимвол «произвольный символ» и модификатор «0 или 1 раз». То есть, например, по запросу «iphone x» мы получим все файлы или пути в которых содержатся «iphonex», «iphone x», «iphone-x», «iphone_x», «iphone/x» и так далее. Но мы не получим например в выдаче файл «iphone__x»(два нижних подчеркивания). И для того чтоб мы его увидели в результатах поиска нам нужно применить метасимвол «.» и модификатор «*». В итоге по запросу «iphone.*x» мы получим все файлы в имени или пути у которых есть текст «iphone» и затем через любое количество символов текст «х», независимом от того где они находятся. У данного метода есть и минусы, например, мы так же получим в выдаче файл с путем «/Iphone/Iphone6-6+/WPmX1zfpTro.jpg» и вроде бы все верно, «iphone» есть и «x» есть.</p>
<p>Идем дальше. Нам нужен файл который начинается на «iphone x». Смотрим наши метасимволы и пишем поисковый запрос «^iphone x». Мы решили, что нам выдало очень много файлов, и мы хотим получить все pdf-ы. Дописываем запрос «^iphone x.*pdf$» В итоге в поисковой выдаче мы получаем все файлы которые начинаются на «iphone x», затем пропускаем 0 или больше раз любой символ и в конце обязательно должен быть текст «pdf». Вроде бы идеально, но так как база собирательная и стандарт хранения данных не систематизирован, натыкаемся на то что в выдаче нет zip и rar архивов, в которые этот pdf может быть запакован.</p>
<p>Ну и последний пример. Скажем нам нужен pdf на ноутбук с платформой quanta и нам для примера без разницы будет это r23 или r33. Начинаем смотреть на наши метасимволы и пишем «ноут» (так как в папки могут называться и ноутбук, и ноутбуки, и ноуты, и ноут), дальше пропускаем 0 или больше символов «.*», затем пишем платформу «quanta», опять пропускаем 0 или больше символов «.*», затем нам без разницы будет это r22 или r33 (r22|r33), и заканчиваться оно должно на pdf «.*pdf$». В итоге получаем вот такой вот запрос «ноут.*quanta.* (r23|r33).*pdf$».
</p>
<button type="button" class="close-button" @click="closeHowTo">Закрыть</button>
</div>

</template>

<script>
import {closeModal} from "jenesius-vue-modal";
import ModalHowTo from "./ModalHowTo.vue";
   export default {
       methods: {
        closeHowTo() {
            closeModal(ModalHowTo);
      },
    },

    }
</script>
<style>
.modal {
    width: 80%;
    border: 1px solid #7BA7AB;
    border-radius: 10px 10px 10px 10px;
    margin: auto;
    background-color: white;
    max-height: 90%;
    overflow: scroll;
  }

p {
  
  width: 90%;
  margin: 0 auto;
}
.close-button{
    height: 42px;
    border: 2px solid #7BA7AB;
    border-radius: 5px 5px 5px 5px;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
}
</style>